import React, { useEffect, useState } from 'react';
import { DndServiceDiagnosisType } from './CodeEncounterDiagnosisServices';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import CodeEncounterDiagnosis from './CodeEncounterDiagnosis';
import { PatientTransactionItemDiagnosisType } from '@chiroup/core';

const bgColors = [' bg-gray-50', ''];

type Props = {
  diagnoses: DndServiceDiagnosisType[];
  onAddAllClicked?: (
    e: React.MouseEvent<HTMLDivElement>,
    val: PatientTransactionItemDiagnosisType,
  ) => void;
  readonly?: boolean;
};

const CodeEncounterDiagnoses: React.FC<Props> = ({
  diagnoses,
  onAddAllClicked,
  readonly = false,
}) => {
  const [diagnosesWithId, setDiagnosesWithId] = useState<any>([]);

  useEffect(() => {
    setDiagnosesWithId(
      diagnoses.map((diagnosis) => ({
        id: diagnosis.data.code as string,
        ...diagnosis,
      })),
    );
  }, [diagnoses]);

  if (!diagnoses?.length) return null;

  return (
    <SortableContext
      id="diagnosis"
      items={diagnosesWithId}
      strategy={verticalListSortingStrategy}
    >
      {diagnoses.map((d, i) => (
        <CodeEncounterDiagnosis
          key={`${d.data.code}-${i}`}
          diagnosis={d}
          color={bgColors[i % 2]}
          onAddAllClicked={onAddAllClicked}
          readonly={readonly}
        />
      ))}
    </SortableContext>
  );
};

export default CodeEncounterDiagnoses;
